/* Velvra – Theme Scripts */
(function () {
  'use strict';

  /* Ankündigungsleiste rotieren */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* Menü-Drawer */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      var d = document.querySelector('[data-drawer="' + open.dataset.drawerOpen + '"]');
      if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      var drawer = e.target.closest('[data-drawer]');
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    });
  });

  /* Countdown – läuft einmal pro Sitzung ab und startet nicht neu */
  document.querySelectorAll('[data-timer]').forEach(function (el) {
    var key = 'velvra-timer-end';
    var end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (err) {}
    if (!end) {
      end = Date.now() + parseInt(el.dataset.minutes || '15', 10) * 60000;
      try { sessionStorage.setItem(key, end); } catch (err) {}
    }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  });

  /* Produkt-Sektionen */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var track = section.querySelector('[data-gallery-track]');
    var thumbs = section.querySelectorAll('[data-thumb-index]');
    var idInput = section.querySelector('[data-variant-id]');
    var qtyInput = section.querySelector('[data-quantity]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var atc = section.querySelector('[data-atc]');

    /* Galerie */
    if (track) {
      var slides = track.children;
      var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      var go = function (i) {
        var n = slides.length;
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var prev = section.querySelector('[data-gallery-prev]');
      var next = section.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.dataset.thumbIndex, 10)); });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = current();
          thumbs.forEach(function (t, k) {
            t.classList.toggle('is-active', k === i);
            if (k === i) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        });
      }, { passive: true });
    }

    function setSelection(variantId, qty, price) {
      if (idInput) idInput.value = variantId;
      if (qtyInput) qtyInput.value = qty || 1;
      if (stickyPrice && price) stickyPrice.textContent = price;
    }

    /* Paket-Auswahl */
    var radios = section.querySelectorAll('[data-bundles] input[type="radio"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        radios.forEach(function (o) { o.closest('.bundle').classList.toggle('is-selected', o.checked); });
        setSelection(r.value, r.dataset.qty, r.dataset.price);
      });
      if (r.checked && stickyPrice) stickyPrice.textContent = r.dataset.price;
    });

    /* Varianten-Dropdown */
    var select = section.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        setSelection(select.value, 1, opt.dataset.price);
        var p = section.querySelector('[data-price]');
        var c = section.querySelector('[data-compare]');
        if (p) p.textContent = opt.dataset.price;
        if (c) c.textContent = opt.dataset.compare || '';
      });
    }

    /* Sticky-Kaufleiste */
    var sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }
  });
})();
